import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-direct-debit'
import Menu from '/components/billing/nav-menu'
import DirectDebit from '/components/billing/direct-debit'

const BillingPaymentDirectDebit = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)
  
  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing - Direct Debit" heading="Direct Debit" HelpText={HelpText} menu={<Menu />}>
      <div className='flex flex-row w-full gap-5 overflow-auto max-w-full mt-10'>
        <DirectDebit/>
      </div>      
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingPaymentDirectDebit